import * as React from "react";
import i18next from "i18next";
import { ToggleSwitch } from "../../Elements/ToggleSwitch";
import { usePrintContext } from "../../Contexts/PrintContext";
import { useMapContext } from "../../Contexts/MapContext";
import { InfoButton } from "../../Popups/Info/InfoButton";

export const PrintOptions = (): JSX.Element => {
    const { configA, printFrame, setPrintFrame } = useMapContext();
    const { useLegend, setUseLegend, useVectors, setUseVectors } = usePrintContext();

    return (
        <>
            <ToggleSwitch
                id={i18next.t("print.legend")}
                title={i18next.t("print.legend")}
                checked={useLegend}
                onClick={setUseLegend}
            ></ToggleSwitch>
            {!configA.print.disableUseVectorsOption && (
                <ToggleSwitch
                    id={i18next.t("print.useVectors")}
                    title={i18next.t("print.useVectors")}
                    checked={useVectors}
                    onClick={setUseVectors}
                    infoButton={<InfoButton text={i18next.t("print.vectorsInfo")} />}
                ></ToggleSwitch>
            )}

            <ToggleSwitch
                id={i18next.t("print.showPreview")}
                title={i18next.t("print.showPreview")}
                checked={printFrame}
                onClick={setPrintFrame}
            ></ToggleSwitch>
            {printFrame && <p className="info-text small unselectable">{i18next.t("print.previewDescription")}</p>}
        </>
    );
};
